module.exports = __webpack_public_path__ + "static/media/invito.6bb30724.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/standart/invito.png
// module id = 810
// module chunks = 20